/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdKeyboardArrowUp,
} from "react-icons/md";

import { cn } from "../../lib/utils";
import CustomButton from "../button/CustomButton";

const MenuMiddleVC = () => {
  const [, setPath] = useState("");
  const [hash, setHash] = useState("");
  const [isFixed, setIsFixed] = useState(false);
  const menuRef = useRef();
  const [menuHeight, setMenuHeight] = useState(0);
  const placeholderRef = useRef();

  useEffect(() => {
    setPath(window.location.pathname);
    setHash(window.location.hash);

    // Função para verificar se o menu chegou ao topo
    if (menuRef.current) {
      setMenuHeight(menuRef.current.offsetHeight); // Captura a altura do menu para o placeholder
    }

    const handleScroll = () => {
      if (menuRef.current && placeholderRef.current) {
        const menuTop = placeholderRef.current.offsetTop; // Posição original do menu
        if (window.scrollY > menuTop) {
          setIsFixed(true);
        } else {
          setIsFixed(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollMenu = (direction) => {
    if (menuRef.current) {
      const scrollAmount = direction === "left" ? -200 : 200;
      menuRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  const isScrollable = () => {
    if (!menuRef.current) return false;
    return menuRef.current.scrollWidth > menuRef.current.clientWidth;
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const sections = useMemo(
    () => ["comoFunciona", "cadastrar", "sobreThopen", "duvidas"],
    []
  );

  useEffect(() => {
    const handleScroll = () => {
      let currentSection = "";

      sections.forEach((section) => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();

          if (
            rect.top <= window.innerHeight * 0.3 &&
            rect.bottom >= window.innerHeight * 0.3
          ) {
            currentSection = `#${section}`;
          }
        }
      });

      if (currentSection !== hash) {
        setHash(currentSection);
        window.history.replaceState(null, null, currentSection);
      }

      if (menuRef.current && placeholderRef.current) {
        const menuTop = placeholderRef.current.offsetTop;
        setIsFixed(window.scrollY > menuTop);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hash, sections]);

  console.log("hash", hash);

  return (
    <>
      {/* Placeholder para ocupar espaço quando o menu está fixo */}
      <div
        ref={placeholderRef}
        style={{ height: isFixed ? `${menuHeight}px` : "0px" }}
      />
      <div
        ref={menuRef}
        className={cn(
          "top-0 left-0 right-0 z-50 w-screen xl:px-4 px-2 py-5 bg-white flex items-center ",
          "",
          isFixed
            ? "shadow-lg fixed top-0 left-0 right-0 z-50 py-2"
            : "relative"
        )}
      >
        <div
          className={cn(
            "w-full max-w-[85rem] px-3 py-5 mx-auto flex justify-between items-center gap-2 overflow-x-auto scroll-smooth snap-x snap-mandatory z-10",
            isFixed ? "py-4" : "py-5"
          )}
        >
          {/* Topo Link (escondido no mobile) */}
          {
            <button
              className={cn(
                "hidden lg:flex items-center text-black gap-1 text-lg font-semibold opacity-0 pointer-events-none transition-opacity duration-200 ease-linear hover:opacity-50",
                isFixed ? "opacity-100 pointer-events-auto" : ""
              )}
              onClick={() => {
                scrollToTop();
                setHash("");
              }}
              title="Voltar ao topo"
              aria-label="Voltar ao topo"
            >
              <MdKeyboardArrowUp className="text-2xl" /> Topo
            </button>
          }

          {/* Menu Items */}
          <div className="flex-1 relative flex justify-center">
            {isScrollable() && (
              <button
                className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-gray-200 p-1 rounded-full shadow z-10"
                onClick={() => scrollMenu("left")}
                title="Menu para esquerda"
                aria-label="Menu para esquerda"
              >
                <MdKeyboardArrowLeft className="text-xl" />
              </button>
            )}
            <div
              ref={menuRef}
              className="flex items-center gap-7 px-4" // Adicionado padding para evitar o corte
            >
              <a
                href="#comoFunciona"
                onClick={() => setHash("#comoFunciona")}
                className={cn(
                  "menu-link relative text-black lg2:text-lg text-base py-1 after:absolute after:h-[4px] after:bg-black after:w-0 after:left-0 after:bottom-[-3px] after:transition-all after:duration-300 hover:after:w-full whitespace-nowrap snap-center",
                  hash === "#comoFunciona" ? "after:w-full" : ""
                )}
                aria-current={hash === "#comoFunciona" ? "page" : undefined}
              >
                Como Funciona
              </a>
              <a
                href="#cadastrar"
                onClick={() => setHash("#cadastrar")}
                className={cn(
                  "menu-link relative text-black lg2:text-lg text-base py-1 after:absolute after:h-[4px] after:bg-black after:w-0 after:left-0 after:bottom-[-3px] after:transition-all after:duration-300 hover:after:w-full whitespace-nowrap snap-center",
                  hash === "#cadastrar" ? "after:w-full" : ""
                )}
                aria-current={hash === "#cadastrar" ? "page" : undefined}
              >
                Como cadastrar
              </a>
              <a
                href="#sobreThopen"
                onClick={() => setHash("#sobreThopen")}
                className={cn(
                  "menu-link relative text-black lg2:text-lg text-base py-1 after:absolute after:h-[4px] after:bg-black after:w-0 after:left-0 after:bottom-[-3px] after:transition-all after:duration-300 hover:after:w-full whitespace-nowrap snap-center",
                  hash === "#sobreThopen" ? "after:w-full" : ""
                )}
                aria-current={hash === "#sobreThopen" ? "page" : undefined}
              >
                Sobre a Thopen
              </a>
              {/* <a
                href="#beneficios"
                onClick={() => setHash("#beneficios")}
                className={cn(
                  "menu-link relative text-black lg2:text-lg text-base py-1 after:absolute after:h-[4px] after:bg-black after:w-0 after:left-0 after:bottom-[-3px] after:transition-all after:duration-300 hover:after:w-full whitespace-nowrap snap-center",
                  hash === "#beneficios" ? "after:w-full" : ""
                )}
              >
                Benefícios
              </a> */}
              <a
                href="#duvidas"
                onClick={() => setHash("#duvidas")}
                className={cn(
                  "menu-link relative text-black lg2:text-lg text-base py-1 after:absolute after:h-[4px] after:bg-black after:w-0 after:left-0 after:bottom-[-3px] after:transition-all after:duration-300 hover:after:w-full whitespace-nowrap snap-center",
                  hash === "#duvidas" ? "after:w-full" : ""
                )}
              >
                Dúvidas frequentes
              </a>
            </div>
            {isScrollable() && (
              <button
                className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-gray-200 p-1 rounded-full shadow z-10"
                onClick={() => scrollMenu("right")}
                title="Menu para direita"
                aria-label="Menu para direita"
              >
                <MdKeyboardArrowRight className="text-xl" />
              </button>
            )}
          </div>
        </div>
        <div
          id="sobre"
          className={cn(
            "w-screen bg-white opacity-100 border-t border-solid border-gray-400 px-5 lg:px-10 py-[1.4rem] flex-col justify-center items-center fixed bottom-0 left-0 right-0 z-50 transition-opacity duration-200 ease-linear",
            isFixed ? "fixed" : "opacity-0 pointer-events-none -z-50"
          )}
        >
          <div className="w-full max-w-[85rem] mx-auto flex flex-row justify-between items-center gap-4">
            <div className="flex flex-2 justify-start font-bold">
              <p className="text-left text-sm lg:text-base">
                Descubra sua economia <br className="block lg:hidden" /> e
                aproveite o benefício exclusivo
              </p>
            </div>
            <div className="flex flex-1 justify-end">
              <CustomButton
                textButton="Simule agora"
                blueVariant
                onClick={scrollToTop}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MenuMiddleVC;
